const e = "AdobeService";
export {
  e as ADOBE_SERVICE
};
